// import reactLogo from './assets/react.svg'
// import viteLogo from '/vite.svg'
//import axiosClient from './axios-client'

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

// import { useEffect } from 'react';
// import axiosClient from './axios-client';
import PrivateRoutes from './utils/ProtectedRoutes';

import Layout from './layout/layout';
import ErrorPage from './pages/error-page/error-page';
import Home from './pages/home/home';
import Tickets from './pages/tickets/Tickets';
import Customers from './pages/tickets/customers/customers';
import Works from './pages/tickets/works/works';
import Items from './pages/tickets/items/items';
import Cars from './pages/tickets/cars/cars';
import Incomes from './pages/tickets/incomes/incomes';
import Outcomes from './pages/tickets/outcomes/outcomes';
import Banks from './pages/tickets/banks/Banks';
import CashBoxes from './pages/tickets/cash-boxes/cash-boxes';
import Login from "./pages/authentication/login/login";
import Register from "./pages/authentication/register/register";
import NotFound from './pages/not-found/not-found';
import Documents from './pages/documents/Documents';
import Customer from './pages/tickets/customers/Customer';
import AddTicket from './pages/tickets/AddTicket';
import { useAuth } from './utils/AuthContext';
import GuestRoutes from './utils/GuestRoutes';
import EditCustomer from './pages/tickets/customers/edit-customer/EditCustomer';
import Entries from './pages/tickets/entries/Entries';
import History from './pages/tickets/history/History';
import Item from './pages/tickets/items/Item';
import EditItem from './pages/tickets/items/edit-item/EditItem';
import Income from './pages/tickets/incomes/Income';
import EditIncome from './pages/tickets/incomes/edit-income/EditIncome';
import Outcome from './pages/tickets/outcomes/Outcome';
import EditOutcome from './pages/tickets/outcomes/edit-outcome/EditOutcome';
import Work from './pages/tickets/works/Work';
import Car from './pages/tickets/cars/Car';
import Bank from './pages/tickets/banks/Bank';
import EditBank from './pages/tickets/banks/edit-bank/EditBank';
import EditCashBox from './pages/tickets/cash-boxes/edit-cashBox/EditCashBox';
import EditWork from './pages/tickets/works/edit-work/EditWork';
import EditCar from './pages/tickets/cars/edit-car/EditCar';
import CashBox from './pages/tickets/cash-boxes/CashBox';
import EditSystem from './pages/tickets/systems/edit-system/EditSystem';
import Systems from './pages/tickets/systems/systems';
import System from './pages/tickets/systems/System';
import AddDocument from './pages/documents/document/add-document/AddDocument';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import EditDocument from './pages/documents/document/edit-document/EditDocument';
import Tables from './pages/tables/Tables';
import DocumentFieldsStructure from './pages/documents/document/document-fields-structure/DocumentFieldsStructure';
import DocumentSettings from './pages/documents/document/document-settings/DocumentSettings';
import Reports from './pages/reports/Reports';
import Settings from './pages/settings/Settings';
import { useEffect, useRef, useState } from 'react';
import { ThemeProvider, Theme } from '@emotion/react';
import { getDesignSettings } from './services/designSettingsService';
import { StyledApp } from './App.styled';
import { createTheme, Theme as MuiTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import { handleApiErrors } from "./services/errorHandling";
import { useErrorBoundary } from "react-error-boundary";
import AccountFieldsStructure from "./pages/account-fields-structure/AccountFieldsStructure";
import DebugHeaders from "./pages/debug-headers/DebugHeaders";

// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// Extend the existing Theme interface
declare module '@emotion/react' {
  export interface Theme {
    colors: {
      main_color: string,
      input_text_color: string,
      input_title_text_color: string,
      input_border_color: string,
      header_color: string,
      background_color: string,
      section_color: string,
      highlight_color: string,
    };
  }
}





function App() {

  const designSettings = useSelector((state: RootState) => state.settings.designSettings);

  const { showBoundary } = useErrorBoundary();
  const { user } = useAuth();

  const [themeColors, setThemeColors] = useState<Theme>();
  const [muiTheme, setMuiTheme] = useState<MuiTheme>();

  const abortControllerRef = useRef<AbortController | null>(null);



  useEffect(() => {
    const fetchUserThemeColors = async () => {
      try {


        if (user) {

          if (designSettings) {
            setThemeColors({ colors: designSettings });
          }

          else {
            abortControllerRef.current?.abort();
            abortControllerRef.current = new AbortController();

            const data = await getDesignSettings("id", "0", "ASC", { user_id: user?.id }, abortControllerRef.current.signal);

            if (data.length > 0) {
              setThemeColors({ colors: data[0] });
            }
          }

        }

        else {
          setThemeColors({
            colors: {
              main_color: 'rgb(38, 38, 38)',
              input_text_color: 'rgb(255, 255, 255)',
              input_title_text_color: 'rgb(155, 155, 155)',
              input_border_color: 'rgba(0, 0, 0, 0.3)',
              header_color: 'rgb(38, 38, 38)',
              background_color: 'rgb(255, 255, 255)',
              section_color: 'rgb(255, 255, 255)',
              highlight_color: 'rgb(64, 122, 214)',
            }
            // colors: {
            //   main_color: 'aliceblue',
            //   input_text_color: 'rgb(255, 255, 255)',
            //   input_title_text_color: 'rgb(155, 155, 155)',
            //   input_border_color: 'rgba(0, 0, 0, 0.3)',
            //   header_color: 'rgb(23, 29, 39)',
            //   background_color: 'rgb(27, 38, 53)',
            //   section_color: 'rgb(35, 48, 68)',
            //   highlight_color: 'rgb(64, 122, 214)',
            // }
          });
        }

      } catch (error) {
        handleApiErrors(error, showBoundary);
      }
    };

    fetchUserThemeColors();
  }, [user, designSettings]);


  useEffect(() => {
    setMuiTheme(createTheme({
      palette: {
        primary: {
          main: themeColors?.colors.highlight_color || "rgb(64, 122, 214)",
        },
        // secondary: {
        //   main: "#4782da"
        // },
        background: {
          // main: "#1B2635"
        }


      },
      typography: {
        h1: {
          fontSize: "3rem",
          fontWeight: 600
        },
        h2: {
          fontSize: "1.75rem",
          fontWeight: 600
        },
        h3: {
          fontSize: "1.5rem",
          fontWeight: 600
        },
        //direction: 'rtl',
      },
    }))
  }, [themeColors]);

  const router = createBrowserRouter([
    {
      path: "/debug-headers",
      element: <DebugHeaders />,
      errorElement: <ErrorPage />,   
    },
    {
      element: <GuestRoutes />,
      children: [
        {
          path: "/login",
          element: <Login />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/register",
          element: <Register />,
          errorElement: <ErrorPage />,
        },
      ]
    },
    {
      element: <PrivateRoutes />,
      children: [
        {
          path: "/",
          element: <Layout />,
          children: [
            {
              path: "/",
              element: <Home />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/",
              element: <Tickets />,
              children: [
                {
                  // /customers
                  path: "customers",
                  element: <Customers />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /works
                  path: "works",
                  element: <Works />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /items
                  path: "items",
                  element: <Items />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /cars
                  path: "cars",
                  element: <Cars />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /incomes
                  path: "incomes",
                  element: <Incomes />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /outcomes
                  path: "outcomes",
                  element: <Outcomes />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /banks
                  path: "banks",
                  element: <Banks />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /cash-boxes
                  path: "cash-boxes",
                  element: <CashBoxes />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /system
                  path: "system",
                  element: <Systems />,
                  errorElement: <ErrorPage />,
                },
              ],
            },

            // /customers*

            {
              path: "/customers/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/customers/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/customers/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/customers/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/customers/:id",
              element: <Customer />,
              errorElement: <ErrorPage />,
              children: [
                {
                  // /customers/:id
                  path: "",
                  element: <EditCustomer />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /customers/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /customers/:id/history
                  path: "history",
                  element: <History />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /items*

            {
              path: "/items/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/items/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/items/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/items/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/items/:id",
              element: <Item />,
              children: [
                {
                  // /items:/id
                  path: "",
                  element: <EditItem />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /items:/id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /items:/id/history
                  path: "history",
                  element: <History />,
                  errorElement: <ErrorPage />,
                },
              ]
            },
            

            
            // /works*

            {
              path: "/works/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/works/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/works/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/works/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/works/:id",
              element: <Work />,
              children: [
                {
                  // /works:/id
                  path: "",
                  element: <EditWork />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /works:/id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /works:/id/history
                  path: "history",
                  element: <History />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /cars*

            {
              path: "/cars/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/cars/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/cars/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/cars/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/cars/:id",
              element: <Car />,
              children: [
                {
                  // /cars/:id
                  path: "",
                  element: <EditCar />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /cars/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /cars/:id/history
                  path: "history",
                  element: <History />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /incomes*

            {
              path: "incomes/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "incomes/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "incomes/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/incomes/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/incomes/:id",
              element: <Income />,
              children: [
                {
                  // /incomes/:id
                  path: "",
                  element: <EditIncome />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /incomes/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /outcomes*

            {
              path: "outcomes/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "outcomes/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "outcomes/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/outcomes/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/outcomes/:id",
              element: <Outcome />,
              children: [
                {
                  // /outcomes/:id
                  path: "",
                  element: <EditOutcome />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /outcomes/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /banks*

            {
              path: "banks/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "banks/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "banks/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/banks/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/banks/:id",
              element: <Bank />,
              children: [
                {
                  // /banks/:id

                  path: "",
                  element: <EditBank />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /banks/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /cash-boxes*

            {
              path: "cash-boxes/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "cash-boxes/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "cash-boxes/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/cash-boxes/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/cash-boxes/:id",
              element: <CashBox />,
              children: [
                {
                  // /cash-boxes/:id
                  path: "",
                  element: <EditCashBox />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /cash-boxes/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            // /system*

            {
              path: "system/structure/search",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "system/structure/browse",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "system/structure/form",
              element: <AccountFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/system/add",
              element: <AddTicket />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/system/:id",
              element: <System />,
              children: [
                {
                  // /system/:id
                  path: "",
                  element: <EditSystem />,
                  errorElement: <ErrorPage />,
                },
                {
                  // /system/:id/journal-entries
                  path: "journal-entries",
                  element: <Entries />,
                  errorElement: <ErrorPage />,
                },
              ]
            },


            
            // /documents*

            {
              path: "/documents",
              element: <Documents />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/structure/search",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/structure/browse",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/add",
              element: <AddDocument />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/add/:documentSettingsId",
              element: <AddDocument />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/structure/account",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/structure/car",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/structure/item",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/structure/work",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/:id",
              element: <EditDocument />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/documents/settings/:id",
              element: <DocumentSettings />,
              errorElement: <ErrorPage />,
            },


            // /tables*

            {
              path: "/tables",
              element: <Tables />,
              errorElement: <ErrorPage />,
            },


            // /structure*

            {
              path: "/structure",
              element: <DocumentFieldsStructure />,
              errorElement: <ErrorPage />,
            },


            // /reports*

            {
              path: "/reports",
              element: <Reports />,
              errorElement: <ErrorPage />,
            },


            // /settings*

            {
              path: "/settings",
              element: <Settings />,
              errorElement: <ErrorPage />,
            },


            // 404
            {
              path: "*",
              element: <NotFound />,
            },

          ]
        },
      ],
    },

    
  ]);




  return (
    <>
      {themeColors && muiTheme && (

        <ThemeProvider theme={themeColors}>
          <MuiThemeProvider theme={muiTheme}>
            <StyledApp>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <RouterProvider router={router} />
              </LocalizationProvider>
            </StyledApp>
          </MuiThemeProvider>
        </ThemeProvider>


      )}
    </>


  )
}

export default App
